import React, { Fragment } from 'react';
import './Schedule.css';

const ScheduleItem = ({ speaker }) => {
    let {
        name4human: topic,
        time4human: time,
        speaker_photo_source: photo = '',
        speakers = ''
    } = speaker;

    let clearTag = (str) => {
        if (str.includes('>')) {
            let start = str.indexOf('>');
            let end = str.lastIndexOf('<');
            return str.substring(start + 1, end);
        } else {
            return str;
        }
    };

    topic = clearTag(topic);
    speakers = clearTag(speakers);

    // Убираем не разрывный пробел, т.к. он рендередиться как символ
    if (topic.includes('&nbsp;')) {
        topic = topic.replace('&nbsp;', ' ');
    }

    let icon = '';
    if (topic.includes('кофе')) {
        icon = <i className="fas fa-coffee b-schedule-container__icon"/>;
    } else if (topic.includes('Обед')) {
        icon = <i className="fas fa-utensils b-schedule-container__icon"/>;
    } else if (topic.includes('Перерыв')) {
        icon = <i className="fas fa-history b-schedule-container__icon"/>;
    }

    let differenceTime = (first, second) => {
        // получение даты из строки (подставляются часы и минуты
        let getDate = (string) => new Date(0, 0, 0, string.split(':')[0], string.split(':')[1]);
        let different = (getDate(second) - getDate(first));

        let hours = Math.floor((different % 86400000) / 3600000);
        let minutes = Math.round(((different % 86400000) % 3600000) / 60000);

        hours = hours === 0 ? '' : hours * 60;

        return `${ minutes + hours } мин`;
    };

    let duration = differenceTime(time.split('–')[0], time.split('–')[1]);

    return (
        <div className="b-schedule-container">
            <div className="b-schedule-container__avatar">
                { icon }
                <img className="b-schedule-container__photo" src={ photo } alt=""/>
            </div>
            <div className="b-schedule-container__details">
                <div className="b-schedule-container__speaker">
                    <h3 className="b-schedule-container__topic">{ topic }</h3>
                    <h4 className="b-schedule-container__speaker">{ speakers }</h4>
                </div>
            </div>
            <div className="b-schedule-container__time-box">
                <h3 className="b-schedule-container__time">{ time }</h3>
                <h4 className="b-schedule-container__duration">{ duration }</h4>
            </div>
        </div>
    );
};

export default ScheduleItem;
